var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3317 3.31967C19.8897 2.09929 18.1257 1.32164 16.252 1.08031C14.3784 0.838982 12.4749 1.14425 10.7706 1.95938C9.06642 2.77451 7.63405 4.06478 6.64594 5.67489C5.65782 7.28501 5.15605 9.14637 5.20102 11.035C5.45093 14.3726 6.9511 17.4929 9.40173 19.7724C10.1158 20.5846 10.802 21.4247 10.802 21.8588V25.1914C10.802 25.6915 10.9005 26.1868 11.0919 26.6489C11.2833 27.1109 11.5638 27.5308 11.9175 27.8845C12.2712 28.2381 12.691 28.5187 13.1531 28.7101C13.6152 28.9015 14.1104 29 14.6106 29H15.3947C16.4049 29 17.3736 28.5987 18.0879 27.8845C18.8021 27.1702 19.2034 26.2015 19.2034 25.1914V21.8588C19.2034 21.4247 19.9455 20.5846 20.6036 19.7724C23.116 17.4394 24.6225 14.2207 24.8043 10.7969C24.8033 9.37318 24.4921 7.96674 23.8924 6.67545C23.2927 5.38415 22.4189 4.23901 21.3317 3.31967ZM15.3947 27.5998H14.6106C13.9719 27.5998 13.3593 27.346 12.9076 26.8944C12.4559 26.4427 12.2022 25.8301 12.2022 25.1914V23.3991H17.8031V25.1914C17.8031 25.8301 17.5494 26.4427 17.0977 26.8944C16.6461 27.346 16.0335 27.5998 15.3947 27.5998ZM19.5954 18.8483C18.5733 19.9825 17.7751 20.8926 17.7751 21.8588V21.9988H12.2022V21.8588C12.2022 20.8926 11.4041 19.9825 10.3819 18.8483C8.19129 16.795 6.84355 13.9997 6.60126 11.007C6.55289 8.98711 7.23405 7.01747 8.5199 5.45902C9.80575 3.90056 11.6102 2.8577 13.6024 2.52154C14.8064 2.31802 16.0403 2.37941 17.2182 2.70141C18.396 3.02341 19.4895 3.59828 20.4225 4.38601C21.3555 5.17373 22.1056 6.15537 22.6205 7.26255C23.1355 8.36974 23.4029 9.57586 23.4041 10.7969C23.4041 14.5776 21.2197 17.042 19.6235 18.8483H19.5954Z",
    fill: "url(#paint0_linear_290_12608)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3045 9.39648H26.9042C26.7185 9.39648 26.5405 9.47025 26.4092 9.60154C26.2779 9.73284 26.2041 9.91092 26.2041 10.0966C26.2041 10.2823 26.2779 10.4604 26.4092 10.5917C26.5405 10.723 26.7185 10.7967 26.9042 10.7967H28.3045C28.4901 10.7967 28.6682 10.723 28.7995 10.5917C28.9308 10.4604 29.0046 10.2823 29.0046 10.0966C29.0046 9.91092 28.9308 9.73284 28.7995 9.60154C28.6682 9.47025 28.4901 9.39648 28.3045 9.39648Z",
    fill: "url(#paint1_linear_290_12608)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80047 10.0966C3.80047 9.91092 3.72671 9.73284 3.59541 9.60154C3.46411 9.47025 3.28604 9.39648 3.10035 9.39648H1.70012C1.51444 9.39648 1.33636 9.47025 1.20506 9.60154C1.07376 9.73284 1 9.91092 1 10.0966C1 10.2823 1.07376 10.4604 1.20506 10.5917C1.33636 10.723 1.51444 10.7967 1.70012 10.7967H3.10035C3.28604 10.7967 3.46411 10.723 3.59541 10.5917C3.72671 10.4604 3.80047 10.2823 3.80047 10.0966Z",
    fill: "url(#paint2_linear_290_12608)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59039 1.20495C3.46041 1.07497 3.28412 1.00195 3.10031 1.00195C2.91649 1.00195 2.7402 1.07497 2.61023 1.20495C2.48025 1.33493 2.40723 1.51122 2.40723 1.69503C2.40723 1.87885 2.48025 2.05514 2.61023 2.18512L4.01046 3.58535C4.07332 3.65233 4.14924 3.70571 4.23353 3.7422C4.31782 3.77869 4.40869 3.79752 4.50054 3.79752C4.5924 3.79752 4.68327 3.77869 4.76756 3.7422C4.85185 3.70571 4.92777 3.65233 4.99063 3.58535C5.0576 3.5225 5.11098 3.44658 5.14747 3.36229C5.18396 3.278 5.20279 3.18712 5.20279 3.09527C5.20279 3.00342 5.18396 2.91254 5.14747 2.82825C5.11098 2.74396 5.0576 2.66805 4.99063 2.60519L3.59039 1.20495Z",
    fill: "url(#paint3_linear_290_12608)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.504 3.79539C25.5958 3.79651 25.6869 3.7784 25.7713 3.74223C25.8557 3.70605 25.9316 3.65262 25.9941 3.58535L27.3943 2.18512C27.5243 2.05514 27.5973 1.87885 27.5973 1.69503C27.5973 1.51122 27.5243 1.33493 27.3943 1.20495C27.2643 1.07497 27.0881 1.00195 26.9042 1.00195C26.7204 1.00195 26.5441 1.07497 26.4142 1.20495L25.0139 2.60519C24.9469 2.66805 24.8936 2.74396 24.8571 2.82825C24.8206 2.91254 24.8018 3.00342 24.8018 3.09527C24.8018 3.18712 24.8206 3.278 24.8571 3.36229C24.8936 3.44658 24.9469 3.5225 25.0139 3.58535C25.0764 3.65262 25.1523 3.70605 25.2367 3.74223C25.3211 3.7784 25.4122 3.79651 25.504 3.79539Z",
    fill: "url(#paint4_linear_290_12608)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9947 16.6078C25.8647 16.4778 25.6884 16.4048 25.5046 16.4048C25.3208 16.4048 25.1445 16.4778 25.0145 16.6078C24.8845 16.7378 24.8115 16.9141 24.8115 17.0979C24.8115 17.2817 24.8845 17.458 25.0145 17.588L26.4148 18.9882C26.4776 19.0552 26.5535 19.1085 26.6378 19.145C26.7221 19.1815 26.813 19.2003 26.9048 19.2003C26.9967 19.2003 27.0876 19.1815 27.1719 19.145C27.2561 19.1085 27.3321 19.0552 27.3949 18.9882C27.4619 18.9253 27.5153 18.8494 27.5518 18.7651C27.5883 18.6808 27.6071 18.59 27.6071 18.4981C27.6071 18.4063 27.5883 18.3154 27.5518 18.2311C27.5153 18.1468 27.4619 18.0709 27.3949 18.008L25.9947 16.6078Z",
    fill: "url(#paint5_linear_290_12608)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00986 16.6078L2.60962 18.008C2.54265 18.0709 2.48927 18.1468 2.45278 18.2311C2.41629 18.3154 2.39746 18.4063 2.39746 18.4981C2.39746 18.59 2.41629 18.6808 2.45278 18.7651C2.48927 18.8494 2.54265 18.9253 2.60962 18.9882C2.67248 19.0552 2.7484 19.1085 2.83269 19.145C2.91698 19.1815 3.00785 19.2003 3.09971 19.2003C3.19156 19.2003 3.28243 19.1815 3.36672 19.145C3.45101 19.1085 3.52693 19.0552 3.58979 18.9882L4.99002 17.588C5.12 17.458 5.19302 17.2817 5.19302 17.0979C5.19302 16.9141 5.12 16.7378 4.99002 16.6078C4.86005 16.4778 4.68376 16.4048 4.49994 16.4048C4.31613 16.4048 4.13984 16.4778 4.00986 16.6078Z",
    fill: "url(#paint6_linear_290_12608)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6126 8.20617L12.4119 12.4069C12.3099 12.5007 12.2401 12.6242 12.2125 12.76C12.1848 12.8958 12.2007 13.0368 12.2579 13.163C12.3104 13.2909 12.3996 13.4003 12.5142 13.4776C12.6289 13.5548 12.7638 13.5964 12.902 13.5971H15.4084L13.8122 15.2074C13.7452 15.2702 13.6918 15.3461 13.6553 15.4304C13.6188 15.5147 13.6 15.6056 13.6 15.6974C13.6 15.7893 13.6188 15.8802 13.6553 15.9645C13.6918 16.0487 13.7452 16.1247 13.8122 16.1875C13.875 16.2545 13.9509 16.3079 14.0352 16.3444C14.1195 16.3809 14.2104 16.3997 14.3022 16.3997C14.3941 16.3997 14.485 16.3809 14.5693 16.3444C14.6536 16.3079 14.7295 16.2545 14.7923 16.1875L17.5928 13.387C17.6948 13.2933 17.7646 13.1697 17.7923 13.0339C17.8199 12.8982 17.804 12.7571 17.7468 12.6309C17.6943 12.5031 17.6051 12.3936 17.4905 12.3164C17.3759 12.2391 17.2409 12.1975 17.1027 12.1968H14.5963L17.5928 9.18634C17.7228 9.05636 17.7958 8.88007 17.7958 8.69626C17.7958 8.51244 17.7228 8.33615 17.5928 8.20617C17.4628 8.07619 17.2865 8.00317 17.1027 8.00317C16.9189 8.00317 16.7426 8.07619 16.6126 8.20617Z",
    fill: "url(#paint7_linear_290_12608)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_290_12608",
    x1: 15.0013,
    y1: 1,
    x2: 15.0013,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_290_12608",
    x1: 27.6043,
    y1: 9.39648,
    x2: 27.6043,
    y2: 10.7967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_290_12608",
    x1: 2.40024,
    y1: 9.39648,
    x2: 2.40024,
    y2: 10.7967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_290_12608",
    x1: 3.80501,
    y1: 1.00195,
    x2: 3.80501,
    y2: 3.79752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_290_12608",
    x1: 26.1995,
    y1: 1.00195,
    x2: 26.1995,
    y2: 3.79544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_290_12608",
    x1: 26.2093,
    y1: 16.4048,
    x2: 26.2093,
    y2: 19.2003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_290_12608",
    x1: 3.79524,
    y1: 16.4048,
    x2: 3.79524,
    y2: 19.2003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_290_12608",
    x1: 15.0024,
    y1: 8.00317,
    x2: 15.0024,
    y2: 16.3997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B96DF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb1);
export default __webpack_public_path__ + "static/media/bulb1.ccd8e3e31338bdacc678b5898ff0824e.svg";
export { ForwardRef as ReactComponent };